import { render, staticRenderFns } from "./StocktakeTaskAndPrint.vue?vue&type=template&id=85b4389e&"
import script from "./StocktakeTaskAndPrint.vue?vue&type=script&lang=js&"
export * from "./StocktakeTaskAndPrint.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports